@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition)}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span matTooltipPosition="below"
                [matTooltip]="fieldConfig.tooltip"
                #tooltip="matTooltip"
                (click)="onClickTooltip(tooltip)">
            <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
          </span>
        }
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)"
             (keyup.enter)="onActivate($event)"
             tabindex="0"
             [ngClass]="{
               'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition,
               'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)
             }">
          <span>
            {{
              'VALUE.DOCUMENT_TYPE_' + document.entityType + '_' + document.type
                | translate
                | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE}
            }}
          </span>
          @if (fieldConfig.computed) {
            <span matTooltipPosition="below"
                  [matTooltip]="'TOOLTIP.COMPUTED_VALUE' | translate"
                  #tooltip="matTooltip"
                  (click)="onClickTooltip(tooltip)">
              <mat-icon fontSet="mdi" fontIcon="mdi-calculator" class="tooltip-icon"></mat-icon>
            </span>
          }
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span class="overlay-icon">
              @if (preconditionsForEdition) {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
              } @else {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" matTooltipPosition="below" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="tooltip-icon"></mat-icon>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span matTooltipPosition="below"
                  [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
              <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
            </span>
          }
        </div>
      }
      <div class="field-container fx-flex-100-66-percent-min-500 fx-layout-col">
        <form autocomplete="off" [formGroup]="form">
          <mat-form-field appearance="outline">
            <mat-label>{{ fieldConfig.label }}</mat-label>
            <mat-select formControlName="field" (keyup.escape)="onEscapeCancel($event)"
                        [required]="fieldConfig.customOptions?.required">
              @for (option of options; track option.value) {
                <mat-option [value]="option.value">
                  {{ option.displayName }}
                </mat-option>
              }
            </mat-select>
            @for (validator of erroredValidators; track validator.type) {
              <mat-error>
                {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
              </mat-error>
            }
          </mat-form-field>
        </form>
        @if (isSingleField) {
          <div class="save-options">
            <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
              <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
            </button>
            <button (click)="onClickSave()"
                    (keyup.escape)="onEscapeCancel($event)"
                    [disabled]="!form.valid"
                    class="button save">
              <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
